import { render } from "./DetailDialog.vue?vue&type=template&id=53dabd3b"
import script from "./DetailDialog.vue?vue&type=script&lang=js"
export * from "./DetailDialog.vue?vue&type=script&lang=js"

import "./DetailDialog.vue?vue&type=style&index=0&id=53dabd3b&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__